// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './mail-recipients.service';
export * from './mailing.service';
// @endindex